<script setup>
defineProps({
    width: {
        type: String,
        default: 'w-176',
    },
})
</script>

<template>
    <div
        :class="width"
        class="flex max-h-[calc(100vh-1.5rem)] max-w-[calc(100vw-1rem)] flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl"
    >
        <slot />
    </div>
</template>
